import { render, staticRenderFns } from "./NavMenuItem.vue?vue&type=template&id=48b146bc&scoped=true"
import script from "./NavMenuItem.vue?vue&type=script&lang=js"
export * from "./NavMenuItem.vue?vue&type=script&lang=js"
import style0 from "./NavMenuItem.vue?vue&type=style&index=0&id=48b146bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b146bc",
  null
  
)

export default component.exports